import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from '@sentry/browser';
import "@babel/polyfill";

import App from "./App";
import { init } from "./stores";
import "./index.scss";

Sentry.init({ dsn: 'https://bf07349f3be14b38b0f6fe1f78b52009@sentry.io/1405627',
  beforeSend(event, hint) {
    const { mechanism } = hint.data && hint.data.stack;
    if (mechanism && mechanism.includes("onunhandledrejection")) {
      return null;
    }
    return event;
  }});

// TODO: we will insert this info from node side when doing SSR

const stores = init(window.DATA);

ReactDOM.hydrate(
  <Provider {...stores}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root"),
);
if (module.hot) {
  console.log("hot reloading active%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.js